import { useState, useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import VenueTTK from "../thingstoknow/VenueTTK";
import PhotographyTTK from "../thingstoknow/PhotographyTTK";
import "../thingstoknow/style.css";
import BridalmakeupTTK from "../thingstoknow/BridalmakeupTTK";
import MehandiTTK from "../thingstoknow/MehandiTTK";
import WeddingDjTTK from "../thingstoknow/WeddingDjTTK";
import DecoratorsTTK from "../thingstoknow/DecoratorsTTK";
import PanditTTK from "../thingstoknow/PanditTTK";
import AnchorTTK from "../thingstoknow/AnchorTTK";
import InvitationTTK from "../thingstoknow/InvitationTTK ";
import GroomWearTTK from "../thingstoknow/GroomWearTTK ";
import LiveMusicBandTTK from "../thingstoknow/LiveMusicBandTTK";
import BirthadayShoppingTTK from "../thingstoknow/BirthadayShoppingTTK ";
import BirthadayClubingTTK from "../thingstoknow/BirthdayClubing";
import BrassBandTTK from "../thingstoknow/BrassBandTTK";
import BusRentalTTK from "../thingstoknow/BusRentalTTK ";
import CakeShopTTK from "../thingstoknow/CakeShopTTK ";
import CarRentalTTK from "../thingstoknow/CarRentalTTK";
import MagicianTTK from "../thingstoknow/MagicianTTK ";
import FlorishTTK from "../thingstoknow/FlorishTTK ";
import GiftsTTK from "../thingstoknow/GiftsTTK ";
import TourPackageTTK from "../thingstoknow/TourPackageTTK ";
import OnRentTTK from "../thingstoknow/OnRentTTK ";
import DestinationWedTTK from "../thingstoknow/DestinationWedTTK ";
import BridalWearTTK from "../thingstoknow/BridalWearTTK";
import WeddingPlannerTTk from "../thingstoknow/WeddingPlannerTTk";
import CateringTTK from "../thingstoknow/CateringTTK";
import ChoreographerTTK from "../thingstoknow/ChoreographerTTK ";
import HelecopterBookingTTK from "../thingstoknow/HelecopterBookingTTK";
import VintageCarTTK from "../thingstoknow/VintageCarTTK";
import { useUserAuth } from "../../context/UserAuthContext";
import ArtistTTK from "../thingstoknow/ArtistTTK";
import CorporateTTK from "../thingstoknow/CorporateTTK";
import GovernmentTTK from "../thingstoknow/GovernmentTTK";
import BirthdayTTK from "../thingstoknow/BirthdayTTK";
import EntryThemeTTK from "../thingstoknow/EntryThemeTTK";
import SafaPagdiTTK from "../thingstoknow/SafaPagdiTTK";
import axios from "axios";
import TempleTTK from "../thingstoknow/TempleTTK";
import JewelleryTTK from "../thingstoknow/JewelleryTTK";
const ThinksToKnowContainer = () => {
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
  const { user, token } = useUserAuth();
  const merchant_id = user.uid;
  const [merchant, setMerchant] = useState();
  // console.log("merc",merchant);

  const getSingleDocumentHandler = async () => {
    try {
      const res = await axios.get(
        `${base_url}/api/v1/users/id/${merchant_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setMerchant(res.data.data.sub_category_id);
    } catch (error) {
      console.log(`Error ${error} `);
    }
  };
  useEffect(() => {
    if (!merchant_id) return;
    getSingleDocumentHandler();
  }, [merchant_id]);
  switch (merchant) {
    case "52vn6kWKmCCUGk6DqKfM":
      return <VenueTTK />;
    case "8x7UFtmckFjIuWUA4oaj":
      return <VenueTTK />;
    case "Gsj5h6LfHMqWKbbWDdeh":
      return <VenueTTK />;
    case "WgPT5AjEU6y3lnpxxkIq":
      return <VenueTTK />;
    case "HUpLhnCk1YhPNM2WAo5t":
      return <VenueTTK />;
     case "eE1sdWjjFcvWZsZWygDu":
      return <VenueTTK />;
    case "CtJccJeldY56EL7B4H8L":
      return <TempleTTK />;
    case "8EaQ32WZPPKQHhCb0rHa":
      return <PhotographyTTK />;
    case "7Uwq0x8t9SB2c266r4Yk":
      return <JewelleryTTK />;
    case "REgfHYF9tUNeip9MoIiJ":
      return <BridalmakeupTTK />;
    case "lNajYmRId9agpdMfQgBP":
      return <MehandiTTK />;
    case "KiR4d4mTOa9wO1Ug794b":
      return <WeddingDjTTK />;
    case "cL3ML2kGQq73UwopisjS":
      return <DecoratorsTTK />;
    case "UVEU5Cu4lBTzTc6U1LLC":
      return <PanditTTK />;
    case "YzLGveDq8B4NGRaMynrF":
      return <AnchorTTK />;
    case "JmVQxGbqLzy5vQleF7Vo":
      return <InvitationTTK />;
    case "KSBiIS1ozXjskiuYSRh8":
      return <GroomWearTTK />;
    case "Ro7Bc5o3VyK0c7rFVBRv":
      return <LiveMusicBandTTK />;
    case "UTYv8zIn3ePt3ZkcKXow":
      return <BirthadayShoppingTTK />;
    case "XfRVyejjN7EPxxVmGNA2":
      return <BirthadayClubingTTK />;
    case "EOwVeI2xdMAWYyMB9Ged":
      return <BrassBandTTK />;
    case "ifDgK6rfWHdve2yAb8IX":
      return <BusRentalTTK />;
    case "v0jnBiBS1p3Y2fTOrgLE":
      return <CakeShopTTK />;
    case "YlYeYg6PFa24U3aUw5XY":
      return <CarRentalTTK />;
    case "kMqFV87nKkkOMDGRLYm8":
      return <MagicianTTK />;
    case "gnv1ceUBFqhcU1F3w6S1":
      return <FlorishTTK />;
    case "NJ24jdxiqTCPhKsPHpfM":
      return <GiftsTTK />;
    case "fklaMSittpqblXbJ5fk4":
      return <TourPackageTTK />;
    case "RBwoc5b7vB2yRl5aHDFm":
      return <OnRentTTK />;
    case "HT33vunkJlPeg1kiP7K2":
      return <DestinationWedTTK />;
    case "To7Chd4Ld4UOo68GzWxq":
      return <DestinationWedTTK />;
    case "YsD4nfH3n21oW1lS9V6I":
      return <DestinationWedTTK />;
    case "tqnzPLgJvzZGg5AR0cQP":
      return <DestinationWedTTK />;
    case "R1Bi9kPxOfsqRwW9oiWk":
      return <BridalWearTTK />;
    case "zqq7qmE7wtG838LDX8hJ":
      return <CateringTTK />;
    case "t5CjPhRmhZAgJ5ZxXKlQ":
      return <WeddingPlannerTTk />;
    case "OcgLXWiDaSZxNQniDKwS":
      return <ChoreographerTTK />;
    case "IYURZPvwTK49OVN3eHqS":
      return <ArtistTTK />;
    case "Eun3JvVRoFLb4nBvq0hH":
      return <HelecopterBookingTTK />;
    case "7kMNlcnAOtLsRMVtqn6R":
      return <VintageCarTTK />;
    case "cLkJjfUeVHHAV3uYy7rN":
      return <GovernmentTTK />;
    case "iAfD04pQNNJjvBLA4jeF":
      return <CorporateTTK />;
    case "FXDStEgXe9RXLiFFFMjn":
      return <SafaPagdiTTK />;
    case "UyZXebMRha8pT62o7NFX":
      return <BirthdayTTK />;
    case "y1cmw5s4CbGXZsEJCfxk":
      return <EntryThemeTTK />;
    default:
      return <Skeleton />;
  }
};

export default ThinksToKnowContainer;
